import React from "react"
import styled from "styled-components"
import { fadeIn } from "./animations"

const Container = styled.div`
  width: 300px;
  height: 300px;
  position: relative;
  top: calc(50vh - 150px);
  left: calc(50% - 150px);
`

const Circle = styled.div`
  width: 80px;
  height: 80px;
  background-color: #ef4565;
  border: 1px solid transparent;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
  transition: 1s;
`
const Orbital = styled.div`
  position: absolute;
  width: ${(props) => (props.width ? props.width : "95%")};
  height: ${(props) => (props.height ? props.height : "95%")};
  left: ${(props) => (props.left ? props.left : "2.5%")};
  top: ${(props) => (props.top ? props.top : "2.5%")};
  border-radius: 50%;
  border: 5px solid #ccc;
  animation: ${(props) =>
    props.rotation
      ? `rotate ${props.rotation} linear 0s infinite`
      : "rotate 2s linear 0s infinite"};
  /* keyframe rotate animation */
  @keyframes rotate {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
  &::after {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    position: relative;
    left: ${(props) => (props.lleft ? props.lleft : "60px")};
    border-radius: 50%;
    background-color: ${(props) => (props.color ? props.color : "#2cb67d")};
  }
`

const LoadingSpinner = () => (
  <Container>
    <Orbital />
    <Orbital
      height="75%"
      width="75%"
      rotation="4s"
      top="calc(50% - 37.5%)"
      left="calc(50% - 37.5%)"
      color="#72757e"
      lleft="40px"
    />
    <Orbital
      height="55%"
      width="55%"
      rotation="5s"
      top="calc(50% - 27.5%)"
      left="calc(50% - 27.5%)"
      color="#7f5af0"
      lleft="20px"
    />
    <Circle />
  </Container>
)

export const Backdrop = styled.div`
  position: absolute;
  left: 6rem;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.75);
  ${Container} {
    transform: scale(0.75);
    opacity: 0.5;
  }
  animation: 0.5s ${fadeIn} ease-out;
`

export default LoadingSpinner
